import { CANLI_BILGILENDIRME_SURUMU } from "@koclukpanel/contracts";
import { CanliIzlemeBilgilendirme } from "@koclukpanel/ui";

/**
 * CANLI ÇALIŞMA İZLEME — BİLGİLENDİRME SAYFASI (F-LIV-07)
 *
 * Öğrenci (Hesabım içinden ya da görev kartındaki "Ayrıntı"dan) ve veli portalı aynı sayfayı açıyor.
 * Salt okunur: rıza/onay düğmesi YOK ve genel aydınlatma metninin yeni sürümü değil (F-LIV-08), yani
 * onay kilidini tetiklemez. Metin ve sürüm paylaşılan bileşende; burada kopyası yok.
 *
 * Dış boşluğu ÇAĞIRAN veriyor (Hesabım alt ekranı `p-4`, veli portalı kendi kolonunda): iki yerin
 * düzeni farklı ve burada sabit bir boşluk ikisinden birini bozardı.
 *
 * Başlık seviyesi 2: Hesabım alt ekranlarında ve veli portalında sayfanın ayrı bir h1'i yok, bu
 * yüzden bileşenin kendi başlığı sayfanın başlığı olarak okunuyor.
 */
export function CanliBilgilendirmeSayfasi() {
  return <CanliIzlemeBilgilendirme surum={CANLI_BILGILENDIRME_SURUMU} />;
}
